import { createServerFn } from "@tanstack/react-start";
import { reviewPayloadSchema, MIN_REVIEW_SECONDS, type PublicReview } from "./reviews-schema";

export const listApprovedReviews = createServerFn({ method: "GET" }).handler(
  async (): Promise<PublicReview[]> => {
    const { serverSupabase } = await import("./contact.server");
    const { data, error } = await serverSupabase()
      .from("reviews")
      .select("id, name, location, child_age, rating, body, created_at")
      .eq("approved", true)
      .order("created_at", { ascending: false })
      .limit(60);

    if (error) {
      console.error("[reviews] list failed", error);
      return [];
    }
    return (data ?? []) as PublicReview[];
  },
);

export const submitReview = createServerFn({ method: "POST" })
  .inputValidator((input: unknown) => reviewPayloadSchema.parse(input))
  .handler(async ({ data }) => {
    // Honeypot filled -> silently accept, never store.
    if ((data.websiteUrl ?? "").trim() !== "") {
      return { ok: true as const };
    }

    if (data.elapsedMs < MIN_REVIEW_SECONDS * 1000) {
      return { ok: false as const, reason: "too_fast" as const };
    }

    const { supabaseAdmin } = await import("@/integrations/supabase/client.server");
    const { error } = await supabaseAdmin.from("reviews").insert({
      name: data.name,
      email: data.email || null,
      location: data.location || null,
      child_age: data.childAge || null,
      rating: data.rating,
      body: data.body,
      approved: false,
    });

    if (error) {
      console.error("[reviews] insert failed", error);
      return { ok: false as const, reason: "storage" as const };
    }

    return { ok: true as const };
  });
